import { SEARCH_MODAL_ITEM_KIND } from '@common/components/SearchModal/search-modal.const'

import type { AcademySearchApiItem } from '@/lib/academySearch/academySearch.interface'
import { ACADEMY_ROUTES } from '@/shared/docs-shared.const'

import { buildSearchModalSubtitle, buildSearchResultHref } from '../search-modal.utils'

export function mapQuickStart(row: AcademySearchApiItem, queryTrimmed: string) {
  return {
    id: `qs-${row.path}`,
    title: row.title,
    href: buildSearchResultHref(`${ACADEMY_ROUTES.quickStart}/${row.slug}`, queryTrimmed, row.headingId),
    shortDescription: buildSearchModalSubtitle(row.description, row.snippet, queryTrimmed),
    kind: SEARCH_MODAL_ITEM_KIND.QuickStart,
  }
}
